import React, {useState} from 'react';

import FormComponentV2 from '../formComponentV2/formComponentV2';
import ImagePreviewComponent from '../imagePreviewComponent/imagePreviewComponent';
import SeparatorComponent from '../../separatorComponent/separatorComponent';

import imageSharingService from '../../../../../services/restServices/ImageSharingService';
import utilsService from '../../../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './imageViewDownloadComponent.css';

const ImageViewDownloadComponent = ({
  hideImgPreviewOnClick = false,
  fileName,
  mediaMessageId,
  src,
  closeFunc,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const downloadImage = async () => {
    setIsDownloading(true);
    const a = document.createElement('a');
    const base64 = await getTempUrl(mediaMessageId);
    let reader = new FileReader();
    reader.readAsDataURL(base64);
    reader.onloadend = function () {
      let base64data = reader.result;
      a.setAttribute('href', base64data);
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      closeFunc();
    };
  };

  const getTempUrl = async (mediaMessageId) => {
    const response = await imageSharingService.getImageByMsgId(mediaMessageId);
    const img = await fetch(
      VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
        response.data.mmDto.tempAccessibleUrl,
      {method: 'GET'},
    );
    let base64 = await img.blob();
    return base64;
  };

  const onImageClick = () => {
    setShowPreview(true);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  return (
    <>
      {showPreview ? (
        <ImagePreviewComponent
          isFullScreen={true}
          src={src}
          onClose={handleClosePreview}
        />
      ) : (
        <div
          className={`et-v2-image-view-download-container ${
            utilsService.getIsClient()
              ? 'et-v2-image-view-download-container-client-side'
              : ''
          }`}>
          <FormComponentV2
            isRightBtnDisabled={isDownloading}
            showRightBtnSpinner={isDownloading}
            formTitle={'Image preview'}
            leftBtnTxt="Close"
            rightBtnTxt="Download"
            formSubTitle={`File name : ${fileName}`}
            onLeftBtnClicked={closeFunc}
            onRightBtnClicked={downloadImage}>
            <SeparatorComponent />
            <ImagePreviewComponent
              src={src}
              onClick={
                isDownloading || hideImgPreviewOnClick ? null : onImageClick
              }
            />
            <SeparatorComponent />
          </FormComponentV2>
        </div>
      )}
    </>
  );
};

export default ImageViewDownloadComponent;
